export const INCOME_TYPE = {
  BOOLEAN_CUTOFF: 'boolean_cutoff',
  RANGE_SELECTION: 'range_selection',
};

export const INCOME_FIELD_MAPPING = {
  BOOLEAN_ANSWER: 'boolean_answer',
  HOUSEHOLD_SIZE_SNAPSHOT: 'household_size_snapshot',
  SELECTED_AMOUNTS: 'selected_range_amounts',
  SELECTED_PERCENTAGES: 'selected_range_percentages',
};
